import React, { useRef } from "react";
import { Polyline, Popup, FeatureGroup } from "react-leaflet";
import Box from "@mui/material/Box";
import PopupBox from "../map/PopupBox";

const RenderContours = ({ data }) => {
  const shapeRef = useRef(null);

  return (
    <FeatureGroup ref={shapeRef}>
      {data.map((geometry, i) => {
        const coordinates = geometry.geometry_json.coordinates;

        return (
          <Polyline
            key={`${geometry.id}_${i}`}
            positions={coordinates}
            pathOptions={{
              color: "red",
              weight: 1,
              opacity: 1,
            }}
          >
            <Popup>
              <PopupBox>
                <Box>Rwy Direction:</Box>
                <Box>{geometry.rwy_direction}</Box>
                <Box>Elevation:</Box>
                <Box>{geometry.elevation}</Box>
              </PopupBox>
            </Popup>
          </Polyline>
        );
      })}
    </FeatureGroup>
  );
};

export default RenderContours;
